import {emptySplitApi} from 'api/apiSlice';

const authApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    logout: builder.mutation({
      query: () => ({
        url: '/auth/logout/',
        method: 'POST',
      }),
    }),
    getMe: builder.query({
      query: () => '/auth/me/',
    }),
    refreshToken: builder.mutation({
      query: () => ({
        url: '/auth/refresh/',
        method: 'POST',
      }),
    }),
  }),
});

export const {useGetMeQuery, useLogoutMutation, useRefreshTokenMutation} =
  authApi;
